<div class="presentation-info-panel">
  <div *ngIf="title" class="info-section">
    <h2 class="info-title">{{ title }}</h2>
  </div>

  <div *ngIf="photographer" class="info-section">
    <div class="info-label">{{ photographerLabel | translate }}</div>
    <div class="info-value">{{ photographer }}</div>
  </div>

  <div *ngIf="publicationDate" class="info-section">
    <div class="info-label">{{ "Published" | translate }}</div>
    <div class="info-value">{{ publicationDate | date: "mediumDate" }}</div>
  </div>

  <div *ngIf="hasEquipment()" class="info-section">
    <div class="info-label">{{ "Equipment" | translate }}</div>

    <div *ngFor="let telescope of equipmentSummary.telescopes" class="equipment-item">
      <fa-icon class="equipment-icon" icon="atom"></fa-icon>
      <span class="equipment-name">{{ formatEquipmentItem(telescope) }}</span>
    </div>

    <div *ngFor="let camera of equipmentSummary.cameras" class="equipment-item">
      <fa-icon class="equipment-icon" icon="camera"></fa-icon>
      <span class="equipment-name">{{ formatEquipmentItem(camera) }}</span>
    </div>

    <div *ngIf="equipmentSummary.filterSummary" class="equipment-item">
      <fa-icon class="equipment-icon" icon="circle"></fa-icon>
      <span class="equipment-name">{{ equipmentSummary.filterSummary }}</span>
    </div>
  </div>

  <div *ngIf="equipmentSummary?.totalIntegration" class="info-section">
    <div class="info-label">{{ "Integration" | translate }}</div>
    <div class="info-value">{{ equipmentSummary.totalIntegration }}</div>
  </div>

  <div [class.show-button]="showViewButton" class="info-section view-button-section">
    <button [attr.aria-label]="'Visit image page' | translate" (click)="visitImage.emit()" class="view-button">
      <fa-icon icon="external-link-alt"></fa-icon>
      <span>{{ "View" | translate }}</span>
    </button>
  </div>
</div>
